import dayjs from "dayjs";

import { BsSearch } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import { FaPrint } from "react-icons/fa";

import { Option } from "@/@types/generics/Option";
import { User } from "@/@types/sintegrada/User";

import { SelectComponent } from "@/components/SelectComponent";

type Props = {
	startDate: string;
	setStartDate: (startDate: string) => void;
	endDate: string;
	setEndDate: (endDate: string) => void;
	minAge?: number;
	setMinAge: (minAge?: number) => void;
	maxAge?: number;
	setMaxAge: (maxAge?: number) => void;
	professionalId?: number;
	setProfessionalId: (professionalId?: number) => void;
	professionals: User[];
	handleFilter: () => void;
	handlePrint: () => void;
};

export function ExamDashboardFilters({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	minAge,
	setMinAge,
	maxAge,
	setMaxAge,
	setProfessionalId,
	professionals,
	handleFilter,
	handlePrint,
}: Readonly<Props>) {
	const professionalOptions = [
		{ name: "Todos os profissionais" } as User,
		...professionals.map((professional) => {
			return { id: professional.id, name: professional.name };
		}),
	].map((professional) => {
		return {
			label: professional.name,
			value: String(professional.id || ""),
		} as Option<string | undefined>;
	});
	return (
		<Form
			onSubmit={(event) => {
				event.preventDefault();
				handleFilter();
			}}
		>
			<Row>
				<Col sm={12} md={6} lg={6} xl={6} xxl={4} className="align-items-center mb-3">
					<Form.Label>Período</Form.Label>
					<div className="d-flex gap-3">
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={startDate}
								placeholder="Data inicial"
								min={dayjs()
									.subtract(2, "years")
									.startOf("day")
									.format("YYYY-MM-DDTHH:mm")}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setStartDate(event.target.value)}
							/>
						</InputGroup>
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={endDate}
								placeholder="data final"
								min={startDate}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setEndDate(event.target.value)}
							/>
						</InputGroup>
					</div>
				</Col>
				<Col sm={12} md={6} lg={6} xl={6} xxl={2} className="d-flex flex-column mb-3">
					<Form.Label>Faixa etária:</Form.Label>
					<InputGroup className="gap-3">
						<Form.Control
							type="number"
							min={0}
							defaultValue={minAge}
							className="fs-7 p-2"
							placeholder="mín"
							onChange={(event) =>
								Boolean(event.target.value)
									? setMinAge(Number(event.target.value))
									: setMinAge()
							}
						/>
						<Form.Control
							type="number"
							min={minAge}
							defaultValue={maxAge}
							className="fs-7 p-2"
							placeholder="max"
							onChange={(event) =>
								Boolean(event.target.value)
									? setMaxAge(Number(event.target.value))
									: setMaxAge()
							}
						/>
					</InputGroup>
				</Col>
				<Col
					sm={12}
					md={6}
					lg={6}
					xl={6}
					xxl={3}
					className="d-flex align-items-center mb-3"
				>
					<InputGroup>
						<Form.Label>Profissional</Form.Label>
						<SelectComponent
							className="w-100"
							name="professional"
							options={professionalOptions}
							onChange={(event) =>
								Boolean((event as Option<string>).value)
									? setProfessionalId(Number((event as Option<string>).value))
									: setProfessionalId()
							}
							defaultValue={{ value: "", label: "Escolha uma opção" }}
							noOptionsMessage={() => "nenhum resultado encontrado na pesquisa"}
						/>
					</InputGroup>
				</Col>
				<Col
					sm={12}
					md={6}
					lg={6}
					xl={6}
					xxl={3}
					className="d-flex align-items-end gap-3 mb-3"
				>
					<Button type="submit" className="text-nowrap">
						<BsSearch className="me-2" />
						Consultar
					</Button>
					<Button
						onClick={handlePrint}
						className="text-white text-nowrap"
						variant="muted"
					>
						<FaPrint className="me-2 text-white" />
						Imprimir
					</Button>
				</Col>
			</Row>
		</Form>
	);
}
